/**
 * Configuration constants for Zone Heatmap visualization
 */

/**
 * Default time horizon for heatmap occupancy calculation (in hours)
 * This serves as the fallback when user hasn't configured a preference.
 *
 * Users can configure the horizon via View Settings:
 * - 24: 1 day
 * - 72: 3 days (default)
 * - 168: 1 week
 *
 * The actual horizon used is: preferences.heatmapHorizonHours || HEATMAP_HORIZON_HOURS
 */
export const HEATMAP_HORIZON_HOURS = 72;

/**
 * Time horizon in minutes (calculated from HEATMAP_HORIZON_HOURS)
 * Used for normalization calculations
 */
export const HEATMAP_HORIZON_MINUTES = HEATMAP_HORIZON_HOURS * 60;

/**
 * Color thresholds for heatmap visualization (Green → Yellow → Red)
 */
export const HEATMAP_COLOR_THRESHOLDS = {
  LOW: 33,    // 0-33%: Green (low occupancy)
  MEDIUM: 66, // 34-66%: Yellow (medium occupancy)
  HIGH: 100,  // 67-100%: Red (high occupancy)
} as const;

/**
 * Base opacity for heatmap overlay (0-1 scale)
 * Lower values make heatmap more subtle
 */
export const HEATMAP_BASE_OPACITY = 0.8; // 80%

/**
 * Gradient radius multiplier for spot visualization
 * Controls the gradient radius (used with clipping to prevent bleeding)
 * 1.0 = full spot coverage, >1.0 = ensures complete fill at edges
 */
export const HEATMAP_GRADIENT_RADIUS_MULTIPLIER = 1.0;
